<template>
  <div style="position: relative;">
    <v-data-table :headers="headers_list" :items="channelList" :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
      <template slot="headerCell" slot-scope="props">
          <div v-if="props.header.text == 'State'">
            <v-menu offset-y :close-on-content-click="false">
                <template slot="activator" slot-scope="{ on }" style="padding: 20px;">
                    <button v-on="on">
                    <span style="display: flex; align-items: center;">
                      <div style="margin-right: 25px; margin-left: 35px;">Type</div>
                      <v-icon small>filter_list</v-icon>
                    </span>
                    </button>
                </template>
                <v-list style="padding: 10px; height: 80px;">
                  <div style="padding: 0px; margin: 0px;">
                    <span>
                      <v-checkbox
                        v-model="state_filters"
                        label="Active"
                        value="active"
                        color="deep-orange"
                        style="padding: 0px; margin: 0px; height: 28px;"
                        hide-details
                      ></v-checkbox>
                    </span>
                  </div>
                  <div style="padding: 0px; margin: 0px;">
                    <span>
                      <v-checkbox
                        v-model="state_filters"
                        label="Archived"
                        value="archived"
                        color="deep-orange"
                        style="padding: 0px; margin: 0px; height: 28px;"
                        hide-details
                      ></v-checkbox>
                    </span>
                  </div>
                </v-list>
            </v-menu>
          </div>

          <span v-else>
              <td>{{ props.header.text }}</td>
          </span>
      </template>
      <template slot="items" slot-scope="props">
        <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.title }}</td>
        <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.name }}</td>
        <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.uuid }}</td>
        <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.state }}</td>
        <template v-if="props.item.type == 'output'">
        <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.transcoder }}</td>
        <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.meta.transcoder_config }}</td>
        <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.meta.transcoder_size }}</td>

        </template>
      </template>
    </v-data-table>
    <v-btn class="deep-orange" v-if="$is_admin()" fab dark small fixed top right style="top: 90px; right: 26px;" @click.stop="open_add_channel"><v-icon>add</v-icon></v-btn>

    <v-toolbar :color="$dark() ? 'grey darken-4' : 'white'" fixed dense right style="top: 87px; left: auto; right: 90px; width: 300px;">
      <v-text-field color="deep-orange" v-model="search_text" ref="search_field" prepend-icon="search" hide-details single-line></v-text-field>
    </v-toolbar>

  </div>
</template>

<script>
export default {
  props: ['type'],
  data () {
    return {
      headers: [
        { text: 'Title', value: 'title', align: 'left' },
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Uuid', value: 'uuid', align: 'left' },
        { text: 'State', value: 'state', align: 'left', sortable: false }
      ],
      output_headers: [
        { text: 'Transcoder', value: 'transcoder', align: 'left' },
        { text: 'Transcoder config', value: 'transcoder_config', align: 'left' },
        { text: 'Transcoder size', value: 'transcoder_size', align: 'left' }
      ],
      pagination: {
        sortBy: 'title',
        descending: true,
        rowsPerPage: 25
      },
      search_text: "",
      state_filters: ['active']
    }
  },
  computed: {
    headers_list () {
      if (this.type == "outputs") {
        return this.headers.concat(this.output_headers);        
      }
      return this.headers;
    },
    channelList () {
      var ret = [];
      var self = this;
      var search = (this.search_text || "").toLowerCase();
      if(this.type == "inputs") {
        ret = this.$store.getters.input_channels
      } else if(this.type == "outputs") {
        ret = this.$store.getters.output_channels
      }
      if(this.state_filters.length > 0) {
        ret = _.filter(ret, (channel) => {
          return this.state_filters.indexOf(channel.state) != -1;
        });
      }
      if (search.length > 0) {
        ret = _.filter(ret, function(channel) {
          ret = false;
          if (channel.title.toLowerCase().includes(search)) ret = true;
          if (channel.name.toLowerCase().includes(search)) ret = true;
          if (channel.uuid.toLowerCase().includes(search)) ret = true;
          if (self.type == "outputs") {
            if ((channel.meta.transcoder_config || "").toLowerCase().includes(search)) ret = true;
            if ((channel.meta.transcoder_size || "").toLowerCase().includes(search)) ret = true;
          }
          return ret;
        })
      }
      return ret;
    }
  },
  mounted () {
    this.$refs.search_field.focus();
  },
  methods: {
    if_archived_color(state) {
      return state == 'archived' ? this.$dark() ? 'grey darken-2 grey--text' : 'grey lighten-4' : ''
    },
    open_add_channel () {
      if (!this.$is_admin()) {
        return;
      }
      this.$router.push("/channels/"+this.type+"/new")
    },
    open_edit_channel (uuid) {
      if (!this.$is_admin()) {
        return;
      }
      this.$router.push("/channels/"+this.type+"/edit/"+uuid)
    }
  }
}
</script>
